import { boolean, object, string } from 'yup'

const KintoContactUsSchema = object().shape({
  enquiry: string().required('Please select your type of enquiry'),
  first_name: string()
    .required('First name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'First name can only contain letters and basic punctuation',
    )
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters')
    .trim(),
  last_name: string()
    .required('Last name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'Last name can only contain letters and basic punctuation',
    )
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters')
    .trim(),
  company_name: string()
    .matches(
      /^[A-Za-z0-9-.,'` ]{0,50}$/,
      'Company name can only contain letters and basic punctuation',
    )
    .when('enquiry', {
      is: (value) => !['New Customer'].includes(value),
      then: (rule) =>
        rule
          .required('Company name is required')
          .max(50, 'Company name must be at most 50 characters')
          .trim(),
    }),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(255)
    .trim(),
  tel: string()
    .required('Phone number is required')
    .matches(/^\d{7,11}$/, {
      message: 'Please enter a valid telephone number',
      excludeEmptyString: true,
    })
    .trim(),
  reg_num: string()
    .trim()
    .matches(
      /(^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|(^[a-zA-Z][0-9]{1,3}[a-zA-Z]{3}$)|(^[a-zA-Z]{3}[0-9]{1,3}[a-zA-Z]$)|(^[0-9]{1,4}[a-zA-Z]{1,2}$)|(^[0-9]{1,3}[a-zA-Z]{1,3}$)|(^[a-zA-Z]{1,2}[0-9]{1,4}$)|(^[a-zA-Z]{1,3}[0-9]{1,3}$)|(^[a-zA-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/,
      {
        message: 'Registration number is invalid',
        excludeEmptyString: true,
      },
    ),
  fleet_size: string().when('enquiry', {
    is: (value) => ['New Customer'].includes(value),
    then: (rule) => rule.trim().required('Fleet size is required'),
  }),
  job_title: string().trim(),
  notes: string().required('Please fill in how we can help').trim(),
  consent: boolean(),
})

export default KintoContactUsSchema
